'use client';
import { routes } from '~constants/routes';
import { useDialogs } from '~entities/dialogs';
import { useNavigationLinks } from '~hooks/useNavigationLinks';
import { usePathname } from '~i18n/navigation';
import { UnreadMessagesBadge } from '~shared/ui/atoms';

import { Container, TabLink, unreadMessagesClass } from './styles';

export const NavigationBar = () => {
	const pathname = usePathname();

	const links = useNavigationLinks();
	const { unreadMessagesCount } = useDialogs();

	// No NavigationBar in Generator internal pages and single chats
	const singleChatRoute =
		pathname.startsWith(routes.chats.home) && pathname !== routes.chats.home;
	if (
		[routes.generate.character, routes.generate.images].includes(pathname) ||
		singleChatRoute
	) {
		return null;
	}

	return (
		<Container id="navigation-bar">
			{links.map(({ path, icon, active, handle }) => (
				<TabLink
					key={path}
					href={path}
					active={active ? 1 : 0}
					onClick={handle}
				>
					{icon}
					{path === routes.chats.home && unreadMessagesCount > 0 && (
						<UnreadMessagesBadge
							className={unreadMessagesClass}
							count={unreadMessagesCount}
						/>
					)}
				</TabLink>
			))}
		</Container>
	);
};
